import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

export const TacticSwitchStyle: SxProps<Theme> = {
  marginBottom: -YodaSpacing.xxLarge,
  width: '25%',
  minWidth: '200px',
};
